<template>
	<div class="body-mobile">
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="3"></nav-step>
			</div>
			<div class="wrapper-body__body" v-if="!!form.student">
				<div class="wrapper-body__body__title">
          <p v-if="studentType===1">填写信息<span>（2/5）</span></p>
          <p v-else>填写信息<span>（1/4）</span></p>
				</div>
				<div class="wrapper-body__body__container" v-if="form">
					<div class="container-field">
						<md-input-item
							v-model="form.student.name"
							:title="studentTypeName+'姓名'"
							placeholder="请输入幼儿姓名"
							is-amount
							:maxlength="40"
						></md-input-item>

						<md-field-item title="性别" solid>
              <md-radio :name="0" v-model="form.student.sex" label="男" inline />
							<md-radio :name="1" v-model="form.student.sex" label="女" inline />
						</md-field-item>

            <md-input-item
              v-model="form.student.birthday"
              :disabled="true"
              title="出生日期"
            ></md-input-item>

						<!--<md-field-item
							title="出生日期"
							name="name"
							arrow="arrow-right"
							align="right"
							:content="birthday"
							@touchstart.native="isDatePickerShow = true">
						</md-field-item>
						<md-date-picker
							ref="datePicker"
							v-model="isDatePickerShow"
							type="custom"
							title="选择出生时间"
							:text-render="textRender"
							:custom-types="['yyyy', 'MM','dd']"
							:default-date="currentDate"
							@change="onDatePickerChange"
							@confirm="onDatePickerConfirm"
						></md-date-picker>-->

						<md-field-item
							title="民族"
              :placeholder="placeholderTextNation"
							arrow="arrow-right"
							:addon="form.student.nationName"
							@click="isPickerShow0 = true">
						</md-field-item>
						<md-picker
							ref="mdPicker0"
							v-model="isPickerShow0"
							:data="pickerData0"
							@confirm="onPickerConfirm(0)"
							title="选择民族"
						></md-picker>

						<md-input-item
              v-model="form.student.idCard"
              :disabled="true"
							title="身份证号"
							placeholder="身份证号"
							clearable
							></md-input-item>
						<template v-if="studentType == 1">
							<md-field-item
								title="幼儿户籍所在地"
								@click="showAddress1 = !showAddress1"
								placeholder="请选择省市区"
								:content="kinderPickerValue1"
								solid
							/>
							<div class="clearfix">
								<md-field-item
									style="text-align:right;"
									title=""
									arrow="arrow-right"
									@click="showAddress2 = !showAddress2"
									placeholder="请选择街道"
									:content="kinderPickerValue2"
									solid
								/>
								<md-picker
									ref="kinderPicker2"
									title="请选择街道"
									v-model="showAddress2"
									:default-value="[]"
									:data="lqStreets"
									:cols="1"
									is-cascade
									@confirm="onKinderPickerConfirm(2)"
									@change="handleChange"
								></md-picker>
							</div>
							<div class="clearfix" v-show="showVillageForm">
								<md-field-item
									style="text-align:right;"
									title=""
									arrow="arrow-right"
									@click="showAddress4 = !showAddress4"
									placeholder="请选择社区"
									:content="kinderPickerValue4"
									solid
								/>
								<md-picker
									ref="kinderPicker4"
									title="请选择社区"
									v-model="showAddress4"
									:default-value="[]"
									:data="lqVillages"
									:cols="1"
									is-cascade
									@confirm="onKinderPickerConfirm(4)"
									@change="handleChange"
								></md-picker>
							</div>
							<md-field-item
								title="现居住地址"
								:disabled="diabledAddress"
								@click="showAddress3 = !showAddress3"
								placeholder="请选择省市区"
								:content="kinderPickerValue3"
								solid
							/>
								<!-- arrow="arrow-right" -->
							<md-tab-picker
								:disabled="diabledAddress"
								title="请选择"
								describe="请选择您所在的省份、城市、区"
								:data="provinceData"
								:content="kinderPickerValue3"
								v-model="showAddress3"
								@change="handleChangeAddress"
							/>
							<md-input-item
								:disabled="diabledAddress"
								v-model="form.student.address"
								placeholder="详细地址"
								:maxlength="100"
							></md-input-item>

						</template>
						<template v-else>
							<md-field-item
								title="申请就读年级"
								:placeholder="placeholderTextGrade"
								arrow="arrow-right"
								:addon="orderGradeName.text"
								@click="isPickerShow1 = true">
							</md-field-item>
							<md-picker
								ref="mdPicker1"
								v-model="isPickerShow1"
								:data="pickerData1"
								@confirm="onPickerConfirm(1)"
								title="选择年级"
							></md-picker>

							<div v-show="canCheckSchool">
								<md-field-item title="原就读学校" solid  @click="clickSchoolArea">
									<md-radio :name="0" v-model="form.containArea" label="区内" inline />
									<md-radio :name="1" v-model="form.containArea" label="区外" inline />
								</md-field-item>
								<div v-show="form.containArea === 0">
									<md-field-item
										arrow="arrow-right"
										:placeholder="placeholderTextSchool"
										:addon="oldSchoolName"
										@click="isPickerShow2 = true">
									</md-field-item>
									<md-picker
										ref="mdPicker2"
										v-model="isPickerShow2"
										:data="pickerData2"
										@confirm="onPickerConfirm(2)"
										title="选择学校"
									></md-picker>

								</div>
								<md-input-item
									v-show="form.containArea !== 0"
									v-model="oldSchoolName"
									title=""
									placeholder="请输入原就读学校名称"
									is-amount
									:maxlength="30"
								></md-input-item>
								<md-field-item title="学籍信息" solid>
									<md-radio :name="1" v-model="form.hasStudentStatus" label="有" inline />
									<md-radio :name="0" v-model="form.hasStudentStatus" label="无" inline />
								</md-field-item>
								<div class="text-warning">（是否有原就读学校签章的学籍信息）</div>
							</div>
						</template>

					</div>
				</div>
			</div>
			<div class="wrapper-body__footer">
				<div class="box-btns">
					<span class="button-primary" @touchstart="handlePreviousStep">上一步</span>
					<span class="button-primary-inset"
						@touchstart="handleNextStep">下一步</span>
				</div>
				<!-- <div><router-link :to="{path: 'bm_login', query: {signupNoticeId: $route.query.signupNoticeId}}">同意并遵守</router-link></div> -->
			</div>
		</div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
	import MobileCommon from '../index/mixins/mobile_common';
	import PageForm from '../index/mixins/page_bm_form';
	// 注意是个二维数组
	import nationsData from './data/nations.json';
	import provinceData from './data/province.json';
  import { setTimeout } from 'timers';
  import config from '../../../config/index';

	let gradeList = [{
			text: '小学 一年级',
			value: '一年级'
		}, {
			text: '小学 二年级',
			value: '二年级'
		}, {
			text: '小学 三年级',
			value: '三年级'
		}, {
			text: '小学 四年级',
			value: '四年级'
		}, {
			text: '小学 五年级',
			value: '五年级'
		}, {
			text: '小学 六年级',
			value: '六年级'
		}, {
			text: '初中 七年级',
			value: '七年级'
		}, {
			text: '初中 八年级',
			value: '八年级'
		}, {
			text: '初中 九年级',
			value: '九年级'
		}];

  export default {
    mixins: [IndexCommon, MobileCommon, PageForm],
    components: {},
    data() {
      return {
        placeholderTextNation: '请选择',
        placeholderTextGrade: '请选择',
        placeholderTextSchool: '请选择原就读学校',
				// 姓名
				name: '',
				// 性别
				sex: '',
				// 身份证号码
				idCard: '',
				// 原就读学校
				schoolAreaType: '',
				// 学校名称
				schoolName: '',

				currentDate: new Date(),
				isDatePickerShow: false,
				// 出生日期
				birthday: '',

				isPickerShow0: false,
				pickerData0: nationsData,

				isPickerShow1: false,
				pickerData1: [gradeList],

				isPickerShow2: false,
				pickerData2: [],

				orderGradeName: {
					text: '',
					value: ''
				},

				oldSchoolName: '',

				areaInSchoolList: [],

				// 幼儿 户籍所在地
				showAddress1: false,
        kinderPickerValue1: '四川省成都市'+config.web.areaName,
				pickerDefaultValue: [],

				// 幼儿户籍 街道社区
				nativeAreaCode: config.web.areaId||'510112',
				nativeAreaName: config.web.areaName||'龙泉驿区',
				nativeCityCode: '5101',
				nativeCityName: '成都市',
				nativeProvinceCode: '51',
				nativeProvinceName: '四川省',

				nativeStreetCode: '',
				nativeStreetName: '',
				nativeVillageCode: '',
				nativeVillageName: '',

        showAddress2: false,
				showAddress4: false,
				showVillageForm: true,

				kinderPickerValue2: '',
				kinderPickerValue4: '',
				// 省市区列表
        provinces: [],
        // 龙泉街道
				lqStreets: [],
				lqVillages: [],

				// 现居住地址
				provinceCode: '',
				provinceName: '',
				cityCode: '',
				cityName: '',
				areaCode: '',
				areaName: '',

				provinceData: provinceData,
        showAddress3: false,
				kinderPickerValue3: '',
				address: '',

				diabledAddress: true
			}
		},

		computed: {
			canCheckSchool() {
				return this.orderGradeName.value != '一年级';
			}
		},

    async mounted() {
			if (this.studentType === 1) {
				this.kinderMounted();
			} else {
				this.studentMounted();
			}
    },
		methods: {
			async studentMounted() {
				// window.step2 = this;
				// 1. 更新formData
				this.updateFormData();
				console.log('[-> Step2] Form ::', this.form);

				if (this.form.oldSchoolName) {
					this.placeholderTextSchool = '';
					this.oldSchoolName = this.form.oldSchoolName;
				}
				if (this.form.orderGradeName) {
					this.placeholderTextGrade = '';
					let value = gradeList.find(v => v.value == this.form.orderGradeName);
					Object.assign(this.orderGradeName, value);

					// if (this.orderGradeName.value == '一年级') {
					// 	this.form.containArea = '';
					// 	this.form.oldSchoolName = '';
					// 	this.form.hasStudentStatus = '';

					// 	this.placeholderTextSchool = '请选择原就读学校';
					// }
				}
				if (this.form.student.nationName) {
					this.placeholderTextNation = '';
				}

				// 2. 转换formData中的某些字段到当前视图中
				// todo
				this.getAreaInSchoolList();
			},
			async kinderMounted() {
				// window.step2 = this;
				// 1. 更新formData
				this.updateFormData();
				console.log('[-> Step2] Form ::', this.form);
				// 获取龙泉街道数据
				await this.getLQStreetsJson();
				let { data } = await this.getPcasCodeJson();
				if (data) {
					this.provinceData = data;
				}

				let { nativeStreetName, nativeStreetCode, nativeVillageName, provinceName, cityName, areaName } = this.form.student;

				if (nativeStreetName) {
					this.kinderPickerValue2 += nativeStreetName;
				}

				this.setVillagesByStreet({ code: nativeStreetCode });

				if (nativeVillageName) {
					this.kinderPickerValue4 = nativeVillageName;
				}

				// 现居住地址
				if (provinceName && cityName && areaName) {
					this.kinderPickerValue3 = provinceName + cityName + areaName;
				}

				if (this.form.student.nationName) {
					this.placeholderTextNation = '';
				}

				setTimeout(() => {
					this.diabledAddress = false;
				}, 500);
			},
			// 获取龙泉驿区的街道和社区信息
      async getLQStreetsJson() {
        let { data, error } = await this.$ajax.gateway('/bm-teacher/IAreaApi_queryAreas', {
					METHOD: 'get',
					studentType: this.studentType,
          areaCode: config.web.areaId
        });
        console.log('龙泉街道-->', data, error);
        if (error) { return this.$message.error('获取龙泉街道失败！'); }
        this.lqStreets = [this.deepIn(data.data)];
        return data.data;
			},

			setVillagesByStreet({ code, name }) {
				let currentStreet = this.lqStreets[0].find(v => v.code === code);
				if (!currentStreet) {
					return;
				}

				let formatedVillages = this.deepIn(currentStreet.children || []);

				this.lqVillages = [formatedVillages];

				if (formatedVillages.length) {
					this.kinderPickerValue4 = '';
					this.showVillageForm = true;
				} else {
					this.showVillageForm = false;
				}

				return this.lqVillages;
			},

			deepIn(list) {
        for (let item of list) {
          item.label = item.name;
          item.value = item.code;
          // item.options = item.children;
          if (item.children && item.children.length > 0) {
            this.deepIn(item.children);
          }
        }
        return list;
			},

			onKinderPickerConfirm(index) {
			  const compt = this.$refs[`kinderPicker${index}`];
        const values = compt.getColumnValues();

        let res = '';
        values.forEach(value => {
          value && (res += `${value.text || value.label} `)
        });
				this[`kinderPickerValue${index}`] = res;

				let { code, name, children } = values[0] || {};

        // console.log(values, '确认街道、社区', code, name, children);
				let form = this.form;

				if (index === 2) {
					// 重新选择了街道
					if (form.student.nativeStreetCode != code) {
						form.orderSchoolName = '';
						form.orderSchoolId = '';
						form.signupQuotaId = '';
					}

					form.student.nativeStreetCode = code;// values[3].code;
					form.student.nativeStreetName = name;// values[3].name;

					this.setVillagesByStreet({ code });

					form.student.nativeVillageCode = '';// values[3].code;
					form.student.nativeVillageName = '';// values[3].name;
				} else if (index === 4) {
										// 重新选择了街道
					if (form.student.nativeVillageCode != code) {
						form.orderSchoolName = '';
						form.orderSchoolId = '';
						form.signupQuotaId = '';
					}

					form.student.nativeVillageCode = code;// values[3].code;
					form.student.nativeVillageName = name;// values[3].name;
				}
      },
			handleChange({ options }) {
				this.address = options
			},

			handleNextStep() {
				if (this.studentType === 1) {
					this.kinderNextStep();
				} else {
					this.studentNextStep();
				}
			},

			kinderNextStep() {
				let { form, $message } = this;

				form.areaCode = this.areaId;
				form.areaName = '四川省成都市'+thia.areaName;

				form.student.nativeProvinceCode = this.nativeProvinceCode;
				form.student.nativeProvinceName = this.nativeProvinceName;
				form.student.nativeAreaCode = this.nativeAreaCode;
				form.student.nativeAreaName = this.nativeAreaName;
				form.student.nativeCityCode = this.nativeCityCode;
				form.student.nativeCityName = this.nativeCityName;

        // 1.验证参数
        if (!form.student.name) {
          return $message.warning('请输入姓名！');
        } else if (typeof form.student.sex === 'undefined') {
          return $message.warning('请选择性别！');
				} else if (!form.student.nationName) {
					return $message.warning('请选择民族！');
				}

				if (!this.kinderPickerValue2) return this.$message.error('户籍地址街道不能为空！');
				if (this.lqVillages[0]) {
					if (this.lqVillages[0].length) {
						if (!this.kinderPickerValue4) return this.$message.error('户籍地址社区不能为空！');
					}
				}

				if (!this.kinderPickerValue3) return this.$message.error('现居住地址不能为空！');

				if (!form.student.address) return this.$message.error('详细地址不能为空！');

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
        // form[xxx] = xxx;

        // 3.保存formData到sessionStorage中
        this.saveFormData(form);

        // // 4.跳转路由
        this.$router.push({
					path: './step3_parent_info',
					query: this.$route.query
				});
			},

			studentNextStep() {
				let { form, $message } = this;

				form.orderGradeName = this.orderGradeName.value;
				form.oldSchoolName = this.oldSchoolName;

        // 1.验证参数
        if (typeof form.student.sex === 'undefined') {
          return $message.warning('请选择性别！');
				} else if (!form.student.nationName) {
					return $message.warning('请选择民族！');
        } else if (!form.orderGradeName) {
					return $message.warning('请选择就读年级！');
        } else if (this.canCheckSchool && typeof form.containArea !== 'number') {
          return $message.warning('请选择原就读学校范围！');
        } else if (this.canCheckSchool && !form.oldSchoolName) {
          return $message.warning('原就读学校名称不能为空！');
				} else if (this.canCheckSchool && typeof form.hasStudentStatus !== 'number') {
          return $message.warning('必须选择学籍信息！');
				}

					// 清空原就读学校
				if (form.orderGradeName == '一年级') {
					console.log('value------', '一年级不用传学校和学籍信息');
					form.oldSchoolName = '';
					form.containArea = 0;
					form.hasStudentStatus = '';
				}

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
        // form[xxx] = xxx;

        // 3.保存formData到sessionStorage中
        this.saveFormData(form);

        // 4.跳转路由
        this.$router.push({
					path: './step3_parent_info',
					query: this.$route.query
				});
			},

			textRender() {
				const args = Array.prototype.slice.call(arguments)
				const typeFormat = args[0] // 类型
				// const column0Value = args[1] // 第1列选中值
				// const column1Value = args[2] // 第2列选中值
				const column2Value = args[3] // 第3列选中值
				if (typeFormat === 'dd') {
					return `*${column2Value}日`
				}
			},
			onDatePickerChange(columnIndex, itemIndex, value) {
				console.log(
					`[Mand Mobile] DatePicker Change\ncolumnIndex: ${columnIndex},\nitemIndex:${itemIndex},\nvalue: ${JSON.stringify(
						value
					)}`
				)
			},
			onDatePickerConfirm(columnsValue) {
				console.log(`[Mand Mobile] DatePicker Confirm\nvalue: ${JSON.stringify(columnsValue)}`)
				this.birthday = this.$refs.datePicker.getFormatDate('yyyy/MM/dd')
			},

			// 学校范围
			clickSchoolArea() {
				// 清空就读学校名称
				this.oldSchoolName = '';

				if (this.form.containArea == 0) {
					this.placeholderTextSchool = '请选择原就读学校';
				}
			},

			// 民族
			onPickerConfirm(index) {
				const values = this.$refs['mdPicker' + index].getColumnValues()
				console.log('-> 选择picker', values);

				let value = values[0];

				// let res = ''
				// values.forEach(value => {
				// 	value && (res += `${value.text || value.label} `)
				// })

				if (index == 0) {
					this.placeholderTextNation = '';
					this.form.student.nationName = value.text;
				} else if (index == 1) {
					this.placeholderTextGrade = '';
					Object.assign(this.orderGradeName, value);

					// console.log('value------', value);
					// // 清空原就读学校
					// if (value.value == '一年级') {
					// 	this.form.oldSchoolName = '';
					// 	this.form.containArea = '';
					// 	this.form.hasStudentStatus = '';
					// }
				} else if (index == 2) {
					this.placeholderTextSchool = '';
					this.oldSchoolName = value.value;
				}
			},

			// 幼儿 现居住地址
			handleChangeAddress({ options }) {
				this.kinderPickerValue3 = options.map(v => v.label).join('');
				console.log('options -------- 现居住地址', options);
				this.form.student.provinceName = options[0] ? options[0].name : '';
				this.form.student.provinceCode = options[0] ? options[0].value : '';
				this.form.student.cityName = options[1] ? options[1].name : '';
				this.form.student.cityCode = options[1] ? options[1].value : '';
				this.form.student.areaName = options[2] ? options[2].name : '';
				this.form.student.areaCode = options[2] ? options[2].value : '';
			},

			// 获取区内就读学校列表
			async getAreaInSchoolList() {
        // 郫都区 区内学校写死
        if(this.studentType===2 && this.areaId==='510117'){
          this.areaInSchoolList = [
            `郫都区红光小学校`,
            `郫都区犀浦镇实验学校`,
            `郫都区犀浦外国语学校`,
            `郫都区团结学校`,
            `郫都区古城学校`
          ];
          this.pickerData2 = [this.formatSchoolList(this.areaInSchoolList)];
          return;
        }



        // 跟进报名通知ID查询学校列表 #李茹钰/2019-03-28#
        let { data, err } = await this.$ajax.gateway('/bm-teacher/ISchoolApi_schoolList', {
					signupNoticeId: this.$route.query.signupNoticeId,
					studentType: this.studentType
        });
        if (err) return this.$message.error('系统错误！查询区域内学校失败！');
        console.log('区域内学校列表', data);
        // 写死学校
        if (!data.data || data.data.length === 0) { data.data = ['实验小学', '龙泉一小', '龙泉二小', '龙泉三小', '龙泉四小', '龙泉五小', '航天小学', '经开实小', '向阳桥小学', '东山国际小学', '大面小学', '洪河小学', '龙华小学', '土桥小学', '玉石小学', '十陵小学', '和平小学', '青龙湖小学', '灵龙小学', '友谊小学', '同安小学', '洛带小学', '客家小学', '西河小学', '西平小学', '跃进小学', '龙井小学', '天平小学', '洪安小学', '黄土小学', '义和小学', '茶店小学', '山泉小学', '柏合小学', '川大附小（东山）', '北大附小', '川师附小（上东）', '青苗学校', '特教学校']; } else { data.data = data.data.map(item => item.name); }
				this.areaInSchoolList = data.data;
				this.pickerData2 = [this.formatSchoolList(this.areaInSchoolList)];
			},

			formatSchoolList(data) {
				return data.map(v => {
					return {
						text: v,
						value: v
					};
				})
			}

		}
  }
</script>

<style lang="stylus" scoped>
	// .wrapper-body__body__container
	// 	>>> .md-picker-column-item
	// 	.column-list
	// 		.column-item
	// 			font-size: .28rem
</style>
